export default __webpack_public_path__ + "static/media/btn_announcement.6af96a1c.png";